// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Activity_wrapper__R65RP","list-item":"Activity_list-item__ShKX_","list":"Activity_list__dv2QV","title":"Activity_title__JTUEK","show-more":"Activity_show-more__eusbY"};